/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_IdInputs */

const en_job_id = /** @type {(inputs: Job_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job ID`)
};

const fr_job_id = /** @type {(inputs: Job_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de tâche`)
};

const de_job_id = /** @type {(inputs: Job_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job-ID`)
};

const it_job_id = /** @type {(inputs: Job_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID lavoro`)
};

const ru_job_id = /** @type {(inputs: Job_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор вакансии`)
};

const es_job_id = /** @type {(inputs: Job_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación del trabajo`)
};

const zh_cn2_job_id = /** @type {(inputs: Job_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`职位编号`)
};

const ja_job_id = /** @type {(inputs: Job_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジョブID`)
};

const hi_job_id = /** @type {(inputs: Job_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जॉब आईडी`)
};

const pt_pt2_job_id = /** @type {(inputs: Job_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da vaga`)
};

/**
* | output |
* | --- |
* | "Job ID" |
*
* @param {Job_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_id = /** @type {((inputs?: Job_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_job_id(inputs)
	if (locale === "de") return de_job_id(inputs)
	if (locale === "it") return it_job_id(inputs)
	if (locale === "ru") return ru_job_id(inputs)
	if (locale === "es") return es_job_id(inputs)
	if (locale === "zh-CN") return zh_cn2_job_id(inputs)
	if (locale === "ja") return ja_job_id(inputs)
	if (locale === "hi") return hi_job_id(inputs)
	if (locale === "pt-PT") return pt_pt2_job_id(inputs)
	return en_job_id(inputs)
});